<template>
  <v-container fluid>
    <v-card flat class="rounded-lg py-2" height="100%">
      <div class="rowDiv contentCenter px-2">
        <div class="rounded-lg pa-1 pageTitle font-weight-black text-h5" style="width: 200px;">{{title}}</div>
        <div>
          <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="tables.user_info.dialogAdd=true">新增</v-btn>
        </div>
        <div>
          <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="exportFile(tables.user_info)" :loading="tables.isExporting">匯出</v-btn>
        </div>
        <v-spacer>
        </v-spacer>
        <div class="text-center mr-5">
          <v-pagination
            circle
            v-model="tables.user_info.page"
            :length="tables.user_info.pageCount"
            total-visible=7
          ></v-pagination>
        </div>
        <v-divider
          class="tableDivider mr-5"
          vertical
          inset
        >
        </v-divider>
        <div class="text-center mr-5 contentCenter">
          共{{tables.user_info.total}}筆
        </div>
        <!-- 每頁顯示筆數 -->
        <div style="width:180px">
          <v-select
            :items="tables.user_info.rowsList"
            outlined
            class="rounded-lg"
            dense
            v-model="tables.user_info.rows"
            hide-details
            prefix="每頁顯示"
            suffix="筆"
          >
          </v-select>
        </div>
      </div>
      <v-data-table
        class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
        hide-default-footer
        :items="tables.user_info.data"
        :headers="tables.user_info.headers"
        hide-default-header
        :items-per-page="tables.user_info.rows"
        :loading="tables.isLoading"
      >
        <template v-slot:header>
          <thead>
            <tr>
              <th
                :style="'width:'+header.width+'px'"
                class="greyTh"
                v-for="header in tables.user_info.headers"
                :key="header.value"
              >
                <div
                  @click="changeSort(header, tables.user_info)"
                  class="sortableThDiv"
                >
                  <div class="sortableThDivText">
                    {{header.text}}
                  </div>
                  <div v-if="header.sortable&&tables.user_info.sortItem===header.value">
                    <v-icon v-if="tables.user_info.sortOrder">mdi-chevron-down</v-icon>
                    <v-icon v-else>mdi-chevron-up</v-icon>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td v-for="header in tables.user_info.headers"
              :key="header.value"
              class="tableTD"
            >
              <div v-if="header.value==='actions'">
                <v-icon
                  size = "35"
                  color="primary"
                  style="cursor: pointer;"
                  @click="openDialog('edit', item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  size = "35"
                  class="ml-2"
                  color="red"
                  style="cursor: pointer;"
                  @click="openDeleteDialog(tables.user_info, item)"
                >
                  mdi-delete
                </v-icon>
                <v-btn
                  class="dialogbtn subBtnColor ml-2"
                  @click="openChangePwd(tables.user_info, item)"
                >
                  修改密碼
                </v-btn>
              </div>
              <div v-else-if="header.value==='area_info'">
                {{item.area_info.join(',')}}
              </div>
              <div v-else>
                {{item[header.value]}}
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          no data available
        </template>
      </v-data-table>
      <!-- 新增/編輯dialog -->
      <v-dialog overlay-opacity="0.2" max-width="800px" v-model="tables.user_info.dialogAdd" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">{{dialogTitle}}</v-card-title>
          <v-card-text>
            <v-form :ref="tables.user_info.formEditRef">
              <div class="rowDiv contentCenter">
                <div style="width:200px">
                  <v-text-field
                    label="人員編號"
                    v-model="tables.user_info.selectedData.USERID"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    :rules="rules.content"
                    :disabled='tables.user_info.isEdit'
                  ></v-text-field>
                </div>
                <div style="width:200px" class="ml-2">
                  <v-text-field
                    label="人員姓名"
                    v-model="tables.user_info.selectedData.USERNAME"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    :rules="rules.content"
                  ></v-text-field>
                </div>
                <div style="width:200px" class="ml-2">
                  <v-text-field
                    label="E-Mail"
                    v-model="tables.user_info.selectedData.EMAIL"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                  ></v-text-field>
                </div>
              </div>
              <div class="rowDiv contentCenter mt-5">
                <div style="width:200px">
                  <v-select
                    label="權限群組"
                    :items="dictionary.rolesList"
                    outlined
                    class="rounded-lg"
                    dense
                    v-model="tables.user_info.selectedData.Role_Id"
                    hide-details
                    :rules="rules.content"
                  >
                  </v-select>
                </div>
                <div style="width:200px" class="ml-2" v-if="tables.user_info.isEdit">
                  <v-text-field
                    label="修改日期"
                    v-model="tables.user_info.selectedData.CREATEDATE"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    disabled
                  ></v-text-field>
                </div>
                <div style="width:200px" class="ml-2" v-if="tables.user_info.isEdit">
                  <v-text-field
                    label="修改人員"
                    v-model="tables.user_info.selectedData.CREATER"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    disabled
                  ></v-text-field>
                </div>
              </div>
              <div class="rowDiv contentCenter mt-5">
                <div style="width:200px" class="ml-2" v-if="!tables.user_info.isEdit">
                  <v-text-field
                    label="密碼"
                    v-model="tables.user_info.selectedData.PWD"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    type="password"
                    :rules="rules.content"
                    autocomplete="null"
                  ></v-text-field>
                </div>
                <div style="width:200px" class="ml-2" v-if="!tables.user_info.isEdit">
                  <v-text-field
                    label="確認密碼"
                    v-model="tables.user_info.selectedData.rePwd"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    type="password"
                    :rules="rules.content"
                  ></v-text-field>
                </div>
              </div>
              <div class="rowDiv contentCenter mt-5 px-16">
                  <div v-for="area in dictionary.area_info" :key="area.value">
                    <v-checkbox
                      v-model="tables.user_info.selectedData.DESCRIPTION"
                      :label="area.text"
                      :value="area.value"
                      color="blue"
                      hide-details
                      class="ml-2"
                    ></v-checkbox>
                  </div>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeDialog(tables.user_info)">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="saveData(tables.user_info)">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 修改密碼dialog -->
      <v-dialog overlay-opacity="0.2" max-width="600px" v-model="tables.user_info.dialogChangePwd" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">更改密碼</v-card-title>
          <v-card-text>
            <v-form :ref="tables.user_info.formPasswordRef">
              <div class="rowDiv contentCenter">
                <div style="width:180px">
                  <v-text-field
                    label="人員編號"
                    v-model="tables.user_info.selectedData.USERID"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    :rules="rules.content"
                    disabled
                  ></v-text-field>
                </div>
                <div style="width:180px" class="ml-2">
                  <v-text-field
                    label="密碼"
                    v-model="tables.user_info.selectedData.PWD"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    type="password"
                    :rules="rules.content"
                  ></v-text-field>
                </div>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeChangeDialog(tables.user_info)">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="changePwd(tables.user_info)">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 確認刪除使用者dialog -->
      <v-dialog overlay-opacity="0.2" max-width="600px" v-model="tables.user_info.dialogDelete" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">刪除使用者</v-card-title>
          <v-card-text>
            <v-form :ref="tables.user_info.formDeleteRef">
              <div class="rowDiv contentCenter">
                <div style="width:180px">
                  <v-text-field
                    label="人員編號"
                    v-model="tables.user_info.selectedData.USERID"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    readonly
                  ></v-text-field>
                </div>
                <div style="width:180px" class="ml-2">
                  <v-text-field
                    label="人員姓名"
                    v-model="tables.user_info.selectedData.USERNAME"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    readonly
                  ></v-text-field>
                </div>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeDeleteDialog(tables.user_info)">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="deleteUSERS(tables.user_info)">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 搜尋 sidebar -->
      <v-navigation-drawer
        app
        clipped
        class="rounded-lg mt-3"
        :width="sidebar.width"
        height="850"
        permanent
      >
        <div class="rowDiv">
          <v-card-title v-if="sidebar.open" class="headline font-weight-bold">篩選條件</v-card-title>
          <v-spacer>
          </v-spacer>
          <v-icon
            size = "30"
            style="cursor: pointer;"
            :class="sidebar.iconClass"
            @click="sidebar.open=!sidebar.open"
          >{{sidebar.icon}}</v-icon>
        </div>
        <v-divider></v-divider>
        <div v-if="sidebar.open">
          <v-card-title style="height:50px" class="searchTitle">人員編號</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-text-field
              v-model="tables.user_info.search.user_id.value"
              class="rounded-lg"
              dense
              outlined
              hide-details
            ></v-text-field>
          </div>
          <v-card-title style="height:50px;" class="searchTitle">人員姓名</v-card-title>
          <div style="width:220px; height:30px" class="ml-4">
            <v-text-field
              v-model="tables.user_info.search.user_true_name.value"
              class="rounded-lg"
              dense
              outlined
              hide-details
            ></v-text-field>
          </div>
        </div>
      </v-navigation-drawer>
    </v-card>
  </v-container>
</template>
<script>

import Service from '../service/service'
export default {
  name: 'Users',
  data: () => ({
    title: '登入人員管理',
    tables: {
      isLoading: false,
      isExporting: false,
      user_info: {
        formEditRef: 'paraForm',
        formDeleteRef: 'deleteForm',
        formPasswordRef: 'newPwdForm',
        urlGet: 'USERS/getPageData',
        urlAdd: 'USERS/Add',
        urlUpdate: 'USERS/update',
        urlDelete: 'USERS/del',
        urlExport: 'USERS/Export',
        headers: [
          { text: '人員編號', value: 'USERID', width: 200, sortable: true },
          { text: '人員姓名', value: 'USERNAME', width: 240, sortable: true },
          { text: '權限群組', value: 'RoleName', width: 240, sortable: true },
          // { text: 'E-Mail', value: 'EMAIL',  sortable: true },
          { text: '管制區域', value: 'area_info', sortable: true },
          { text: '', value: 'actions', width: 240, sortable: false }
        ],
        rows: 10,
        sortItem: 'USERID',
        sortOrder: false,
        pageCount: 0,
        page: 1,
        total: 0,
        rowsList: [10, 20, 30, 40, 50],
        search: {
          user_id: {
              name: 'USERID',
              value: '',
              displayType: 'like'
          },
          user_true_name: {
              name: 'USERNAME',
              value: '',
              displayType: 'like'
          }
        },
        data: [],
        selectedData: { 
          USERID: '',
          USERNAME: '',
          DESCRIPTION: [],
          Role_Id: null,
          RoleName: '',
          PWD: '',
          rePwd: '',
          EMAIL: '',
          // 以下為編輯時，才能有 key (否則新增時會出錯)
          // CREATEDATE: '',
          // CREATER: ''
        },
        isEdit: false,
        dialogAdd: false,
        dialogChangePwd: false,
        dialogDelete: false
      }
    },
    rules: {
      content: [v => !!v || 'Required']
    },
    sidebar: {
      open: true, 
      width: 260,
      icon: 'mdi-arrow-expand-left',
      iconClass: 'mr-5'
    },
    dictionary: {
      rolesList: [
        {
          text: '',
          value:''
        }
      ],
      area_info: [],
      userGroupList: []
    }
  }),
  mounted: function () {
    this.getDictionary()
  },
  watch: {
    'sidebar.open' () {
        this.sidebar.width = this.sidebar.open ? 260 : 70
        this.sidebar.icon = this.sidebar.open ? 'mdi-arrow-expand-left' : 'mdi-tune-variant'
        this.sidebar.iconClass = this.sidebar.open ? 'mr-5' : 'mr-5 my-5'
    },
    'tables.user_info.page': {
      handler: function (nvalue, ovalue) {
        if (ovalue === undefined) return
        if (nvalue !== ovalue) { this.getPageData(this.tables.user_info) }
      }
    },
    'tables.user_info.rows': {
      handler: function (nvalue, ovalue) {
        if (ovalue === undefined) return
        if (nvalue !== ovalue) { this.tables.user_info.page === 1 ? this.getPageData(this.tables.user_info) : this.tables.user_info.page = 1 }
      }
    },
    'tables.user_info.search.user_id.value' : {
      immediate: true,
      handler: function (nvalue, ovalue) {
        if (ovalue === undefined) return
        if (nvalue !== ovalue) { this.tables.user_info.page === 1 ? this.getPageData(this.tables.user_info) : this.tables.user_info.page = 1 }
      }
    },
    'tables.user_info.search.user_true_name.value' : {
      immediate: true,
      handler: function (nvalue, ovalue) {
        if (ovalue === undefined) return
        if (nvalue !== ovalue) { this.tables.user_info.page === 1 ? this.getPageData(this.tables.user_info) : this.tables.user_info.page = 1 }
      }
    },
  },
  props: {
    user: null,
    permissions: null,
    isMobile: null
  },
  computed: {
    dialogTitle () {
      if (this.tables.user_info.isEdit) {
        return '編輯用戶'
      } else {
        return '新增用戶'
      }
    }
  },
  methods: {
    showAlert (type, message) {
      var alert = {
        alertType: null,
        alertMessage: '',
        alertIcon: null
      }
      if (type === 'success') {
        alert.alertType = 'success'
        alert.alertIcon = 'mdi-check-circle'
      } else {
        alert.alertType = 'error'
        alert.alertIcon = 'mdi-alert-circle'
      }
      alert.alertMessage = message
      this.$emit('setAlert', alert)
    },
    changeSort (header, table) {
      if (!header.sortable) return

      if (header.value === table.sortItem) {
        table.sortOrder = !table.sortOrder
      } else {
        table.sortOrder = true
        table.sortItem = header.value
      }
      this.getPageData(table)
    },
    openDialog (type, item) {
      var table = this.tables.user_info
      if (type === 'edit') {
        table.isEdit = true
        var selectedData = table.selectedData
        selectedData.USERID = item.USERID
        selectedData.USERNAME = item.USERNAME
        selectedData.DESCRIPTION = item.DESCRIPTION
        selectedData.Role_Id = item.Role_Id
        selectedData.RoleName = item.RoleName
        selectedData.PWD = item.PWD
        selectedData.rePwd = item.rePwd
        selectedData.EMAIL = item.EMAIL
        // 以下為編輯時，才能有 key
        selectedData.CREATEDATE = item.CREATEDATE
        selectedData.CREATER = item.CREATER
      } else {
        table.isEdit = false

        //this.resetSelectedData()
      }
      table.dialogAdd = true
    },
    closeDialog (table) {
      table.isEdit = false
      table.dialogAdd = false
      this.resetSelectedData()
      if (this.$refs[table.formEditRef]) {
        this.$refs[table.formEditRef].resetValidation()
      }
      // // 暫時特別重取頁面資料
      // this.getDictionary()
    },
    
    getDictionary () {
      this.dictionary.rolesList = []
      this.dictionary.area_info = []
      this.dictionary.userGroupList = []
      var parm = ['roles', 'area_info', 'USERGROUPS']
      Service.getDictionary(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200) {
            this.showAlert('error', response.data.message)
          } else {
            var rolesIndex = response.data.map(function (item) { return item.dicNo }).indexOf('roles')
            var areaIndex = response.data.map(function (item) { return item.dicNo }).indexOf('area_info')
            var userGroupIndex = response.data.map(function (item) { return item.dicNo }).indexOf('USERGROUPS')
            var rolesList = response.data[rolesIndex].data
            var area_info = response.data[areaIndex].data
            var userGroupList = response.data[userGroupIndex].data
            rolesList.forEach(element => {
              var role = {
                value: element.key,
                text: element.value
              }
              this.dictionary.rolesList.push(role)
            })
            area_info.forEach(element => {
              var area = {
                value: element.key,
                text: element.value
              }
              this.dictionary.area_info.push(area)
            })
            userGroupList.forEach(element => {
              var userGroup = {
                value: element.key,
                text: element.value
              }
              this.dictionary.userGroupList.push(userGroup)
            })
            // console.log(rolesList, userGroupList)
            this.getPageData(this.tables.user_info)
          }
        })
    },
    getPageData (table) {
      this.tables.isLoading = true
      table.pageCount = 0
      table.data = []
      var wheres = []
      for (var variable in table.search) {
        wheres.push(table.search[variable])
      }
      var parm = {
        page: table.page,
        rows: table.rows,
        order: table.sortOrder ? 'desc' : 'asc',
        sort: table.sortItem,
        wheres: JSON.stringify(wheres),
        url: table.urlGet
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            table.total = response.data.total
            table.pageCount = Math.ceil(table.total / table.rows)
            table.data = response.data.rows
            table.data.forEach(element => {
              var groups = this.dictionary.userGroupList.find(x => x.value === element.USERID)
              if(groups) {
                element.Role_Id = groups.text
              }
              var role = this.dictionary.rolesList.find(x => x.value === element.Role_Id)
              if(role) {
                element.RoleName = role.text
              }
              if (element.DESCRIPTION) {
                element.area_info = []
                element.DESCRIPTION = element.DESCRIPTION.split(',')
                element.DESCRIPTION.forEach(x => {
                  var area = this.dictionary.area_info.find(o => o.value === x)
                  if (area) { 
                    element.area_info.push(area.text)
                  }
                })
              }
              else {
                element.area_info = []
                element.DESCRIPTION = []
              }
            })
            // console.log(table.data)
            this.$forceUpdate()
          }
        })
        .finally(() => {
          this.tables.isLoading = false
        })
    },
    saveData (table) {
      if (this.$refs[table.formEditRef].validate()) {
        if (table.selectedData.PWD === table.selectedData.rePwd || table.isEdit) {
          if (table.selectedData.DESCRIPTION.length !== 0) {
            table.selectedData.DESCRIPTION = table.selectedData.DESCRIPTION.toString()
          } else {
            table.selectedData.DESCRIPTION = null
          }
          table.selectedData.rePwd = ''
          var url = table.isEdit ? table.urlUpdate : table.urlAdd
          Service.updateData(table.selectedData, url)
            .then((response) => {
              // console.log(response)
              if (response.status !== 200 || !response.data.status) {
                this.showAlert('error', response.data.message)
              } else {
                this.showAlert('success', response.data.message)
                this.getDictionary()
                this.closeDialog(table)
              }
            })
        } else {
          this.showAlert('error', '密碼與確認密碼不相同')
        }
      }
    },
    openChangePwd (table, item) {
      table.selectedData.USERID = item.USERID
      table.selectedData.PWD = item.PWD
      table.dialogChangePwd = true
    },
    closeChangeDialog (table) {
      table.dialogChangePwd = false
      this.resetSelectedData()
      if (this.$refs[table.formPasswordRef]) {
        this.$refs[table.formPasswordRef].resetValidation()
      }
    },
    changePwd (table) {
      if (this.$refs[table.formPasswordRef].validate()) {
        Service.changePwd(table.selectedData.PWD, table.selectedData.USERID)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              this.getPageData(table)
              this.closeChangeDialog(table)
            }
          })
      }
    },
    exportFile (table) {
      this.tables.isExporting = true
      var wheres = []
      for (var variable in table.search) {
        wheres.push(table.search[variable])
      }
      var parm = {
        wheres: JSON.stringify(wheres),
        url: this.tables.user_info.urlExport
      }
      Service.exportFile(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200) {
            this.showAlert('error', response.data.message)
          } else {
            var filename = this.title + '.xlsx'
            var downloadURL = ''
            var binaryData = []
            binaryData.push(response.data)
            downloadURL = URL.createObjectURL(new Blob(binaryData, { type: 'application/octet-stream' }))
            var link = document.createElement('a')
            link.href = downloadURL
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            link = null
          }
        })
      .finally(() => {
        this.tables.isExporting = false
      })
    },
    openDeleteDialog (table, item) {
      table.selectedData.USERID = item.USERID
      table.selectedData.USERNAME = item.USERNAME
      table.dialogDelete = true
    },
    closeDeleteDialog (table) {
      table.dialogDelete = false
      this.resetSelectedData()
      if (this.$refs[table.formDeleteRef]) {
        this.$refs[table.formDeleteRef].resetValidation()
      }
    },
    deleteUSERS (table) {
      if (this.$refs[table.formDeleteRef].validate()) {
        
        var deleteList = []
        deleteList.push(table.selectedData.USERID)
        Service.deleteData(deleteList, table.urlDelete)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              this.getPageData(table)
              table.dialogDelete = false
            }
          })
      }
    },
    resetSelectedData () {
      var selectedData = this.tables.user_info.selectedData
      selectedData.USERID = ''
      selectedData.USERNAME = ''
      selectedData.DESCRIPTION = []
      selectedData.Role_Id = null
      selectedData.RoleName = ''
      selectedData.PWD = ''
      selectedData.rePwd = ''
      selectedData.EMAIL = ''
      // 以下為編輯時，才能有 key
      if ('CREATEDATE' in selectedData)
        delete selectedData.CREATEDATE
      if ('CREATER' in selectedData)
        delete selectedData.CREATER
    }
  }
}
</script>
